import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./pages/home/home.component').then(
                (mod) => mod.HomeComponent
            ),
    },
    {
        path: 'about-us',
        loadComponent: () =>
            import('./pages/about-us/about-us.component').then(
                (mod) => mod.AboutUsComponent
            ),
    },
    {
        path: 'solutions',
        loadComponent: () =>
            import('./pages/solutions/solutions.component').then(
                (mod) => mod.SolutionsComponent
            ),
    },
    {
        path: 'insights',
        loadComponent: () =>
            import('./pages/insights/insights.component').then(
                (mod) => mod.InsightsComponent
            ),
    },
    {
        path: 'media-corner',
        loadComponent: () =>
            import('./pages/media-corner/media-corner.component').then(
                (mod) => mod.MediaCornerComponent
            ),
    },
    // {
    //     path: 'media-corner-detail',
    //     loadComponent: () =>
    //         import('./pages/media-corner-detail/media-corner-detail.component').then(
    //             (mod) => mod.MediaCornerDetailComponent
    //         ),
    // },
    {
        path: 'contact-us',
        loadComponent: () =>
            import('./pages/contact-us/contact-us.component').then(
                (mod) => mod.ContactUsComponent
            ),
    },
    // {
    //     path: 'global',
    //     loadComponent: () =>
    //         import('./pages/global/global.component').then(
    //             (mod) => mod.GlobalComponent
    //         ),
    // },
    {
        path: '**',
        loadComponent: () =>
            import('./pages/page-not-found/page-not-found.component').then(
                (mod) => mod.PageNotFoundComponent
            ),
        // data: { error_code: 404 },
    },
    {
        path: 'not-found',
        loadComponent: () =>
            import('./pages/page-not-found/page-not-found.component').then(
                (mod) => mod.PageNotFoundComponent
            ),
        // data: { error_code: 404 },
    },
];
